<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'EmailNotifications',
  data: vm => ({
   emailSettings: [
      {
        emailType: vm.$enums.EmailType.PdfValidationFinished,
        isEnabled: false
      },
      {
        emailType: vm.$enums.EmailType.AutocompleteDeletionInfo,
        isEnabled: false
      }
    ]
  }),
  computed: {
    ...mapState({
      userSettings: state => state.settings
    })
  },
  created() {
    this.assignUserSettingsValues()
  },
  methods: {
    ...mapActions(['saveUserSettings']),
    assignUserSettingsValues() {
      this.emailSettings.forEach(emailSetting => {
        let userSetting = this.userSettings.emailSettings ? this.userSettings.emailSettings.find(setting => setting.emailType === emailSetting.emailType) : null
        if (userSetting) {
          emailSetting.isEnabled = userSetting.isEnabled
        } else {
          emailSetting.isEnabled = emailSetting.emailType === this.$enums.EmailType.AutocompleteDeletionInfo
        }
      })
    },
    handleNotificationChange() {
      this.saveUserSettings({
        emailSettings: this.emailSettings
      })
        .then(() => {
          this.$notify(this.$t('global.save.settings.success'), { type: 'success' })
        })
        .catch(() => {
          this.$notify(this.$t('global.save.settings.error'), { type: 'error' })
        })
    }
  }
}
</script>
<template>
  <div>
    <v-card flat tile outlined color="transparent" class="pa-4">
      <v-card-text>
        <v-row align="center" justify="center">
          <v-col cols="12" md="6">
            <v-card outlined class="mb-4">
              <v-card-title>
                <v-spacer />
                <v-row class="pl-2">
                  <v-col cols="12" class="justify-center">
                    <span> {{ $t('component.profile.accountManagement.notifications') }} </span>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-card-text>
                <v-row align="center" justify="center" class="text-center">
                  <v-col cols="12" class="justify-center">
                    <span>{{ $t('component.profile.accountManagement.notification.info') }} </span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-checkbox
                      v-for="emailSetting in emailSettings"
                      :key="emailSetting.emailType"
                      v-model="emailSetting.isEnabled"
                      :label="$t(('component.profile.accountManagement.') + ($enums.EmailType.getKey(emailSetting.emailType)))"
                      hide-details
                      @change="handleNotificationChange">
                    </v-checkbox>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>
